import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, PenLineIcon, MessageCircleIcon, ShieldIcon } from 'lucide-react';
const features = [{
  icon: ZapIcon,
  title: 'The Anti-Blank Script',
  description: 'Qué decir en 15 segundos cuando te preguntan algo de la nada y no tienes la respuesta.'
}, {
  icon: PenLineIcon,
  title: 'The Power Brevity',
  description: 'Cómo escribir correos y mensajes que proyecten autoridad sin pedir perdón.'
}, {
  icon: MessageCircleIcon,
  title: 'The Small Talk Killer',
  description: '15 iniciadores de charla que no dan vergüenza ajena.'
}, {
  icon: ShieldIcon,
  title: 'The Panic Recovery',
  description: 'Cómo recuperar la compostura en segundos si sientes que te estás bloqueando en una reunión.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function SolutionSection() {
  return <section className="py-20 md:py-32 px-6 bg-black text-white" data-id="element-53">
      <div className="max-w-3xl mx-auto" data-id="element-54">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-55">
          <h2 className="text-3xl md:text-5xl font-extrabold mb-6 tracking-tight" data-id="element-56">
            Te presento: SOCIAL CHEAT CODES.
          </h2>
          <p className="text-xl text-gray-300 mb-12 leading-relaxed" data-id="element-57">
            No es un libro de psicología. Es un arsenal de "Cheat Codes"
            (atajos) sociales para profesionales introvertidos.
          </p>
          <h3 className="text-2xl font-bold text-white mb-8" data-id="element-58">
            ¿Qué vas a obtener?
          </h3>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="space-y-8" data-id="element-59">
          {features.map((feature, index) => <motion.div key={index} variants={itemVariants} className="flex items-start gap-5" data-id="element-60">
              <div className="bg-white/10 p-3 rounded-xl shrink-0" data-id="element-61">
                <feature.icon className="w-6 h-6 text-white" data-id="element-62" />
              </div>
              <div data-id="element-63">
                <h4 className="text-xl font-bold text-white mb-2" data-id="element-64">
                  {feature.title}
                </h4>
                <p className="text-gray-400 leading-relaxed" data-id="element-65">
                  {feature.description}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}